import {
  isDivisionControlled,
  selectedDivisionId,
  userDetails,
} from "@ui/Utils/helper";
import commonConfig from "config/commonConfig";
import enums from "helpers/enums";
import { getMainClient } from "./common/common.utils";

const mainClient = getMainClient();
export const getProductImageUri = ({ styleNo, imageFlag, client, division }) =>
  imageFlag
    ? `https://storage.googleapis.com/${commonConfig.dataEngineBucketName}/${
        enums.keywords.dataEngine
      }/${
        mainClient?.id ||
        userDetails?.client?._id ||
        client?._id ||
        client ||
        "clientLess"
      }/${
        isDivisionControlled || division?._id
          ? `${division?._id || selectedDivisionId}/`
          : ""
      }products/${styleNo}.png`
    : "https://storage.googleapis.com/sheen-upload/Assets/Common/oopsNotFound.png";
